import { ProjectTrends } from "../Interface/Trends"
import { API, APIResponse } from '@/components/_Shared/API/API';

/**
 * Gets the Project Trend data from just this API.
 * This should just be enough to get the data for the Project Trends chart.
 * This will gather data from the last 12 months.
 * The data returned with be:
 *  - Revenue from completed projects (including the total invoice amount)
 *  - Expenses from completed projects (including the total consulting fee and project construction budget)
 * 
 * @returns The Project Trend data from the API
 */
export function getProjectTrends(): Promise<APIResponse<ProjectTrends[]>> {
    return API.get<ProjectTrends[]>("/api/projects/trends")
}